// extracted by mini-css-extract-plugin
export var createdDate = "_li-1";
export var divider = "_li-2";
export var headerDivider = "_li-3";
export var messagesCard = "_li-0";
export var messagesContainer = "_li-6";
export var messagesContainerWrapper = "_li-4";
export var showLeftPanelButton = "_li-8";
export var topButtons = "_li-7";
export var withPadding = "_li-5";